import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const REGIONS = ["Greater Accra", "Ashanti", "Eastern", "Western", "Central", "Volta", "Northern", "Upper East", "Upper West", "Bono", "Bono East", "Ahafo", "Oti", "Savannah", "Western North", "North East"];

export default function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "", region: "Greater Accra", role: "buyer" });
  const { register } = useAuth();
  const nav = useNavigate();

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    const r = await register(form);
    if (r.ok) { toast.success("Welcome to AgriNuhse!"); nav(form.role === "seller" ? "/seller" : "/marketplace"); }
    else toast.error(r.error);
  };

  return (
    <div className="min-h-[70vh] grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <img src="https://images.unsplash.com/photo-1665904285523-47c0a6fdfc0e?w=1200&q=80" alt="Fresh peppers" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#C85A32]/70 to-transparent" />
        <div className="absolute bottom-8 left-8 right-8 text-white">
          <div className="text-xs uppercase tracking-widest font-bold text-[#D99B26]">Join AgriNuhse</div>
          <h2 className="text-3xl font-black mt-2">Sell more. Source better.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-3" data-testid="register-form">
          <h1 className="text-3xl font-extrabold text-[#1E4D3B]">Create account</h1>

          <div className="grid grid-cols-2 gap-2">
            <button type="button" onClick={() => setForm({ ...form, role: "buyer" })}
              className={`py-2 rounded-lg text-sm font-bold border-2 ${form.role === "buyer" ? "border-[#C85A32] bg-[#C85A32] text-white" : "border-[#E5D9C8]"}`}
              data-testid="register-role-buyer">I'm a Buyer</button>
            <button type="button" onClick={() => setForm({ ...form, role: "seller" })}
              className={`py-2 rounded-lg text-sm font-bold border-2 ${form.role === "seller" ? "border-[#1E4D3B] bg-[#1E4D3B] text-white" : "border-[#E5D9C8]"}`}
              data-testid="register-role-seller">I'm a Farmer/Seller</button>
          </div>

          <div>
            <label className="text-xs uppercase font-bold tracking-widest text-[#8C6D53]">Full name</label>
            <input required value={form.name} onChange={update("name")} className="w-full mt-1 px-3 py-2.5 border border-[#E5D9C8] rounded-lg" data-testid="register-name-input" />
          </div>
          <div>
            <label className="text-xs uppercase font-bold tracking-widest text-[#8C6D53]">Email</label>
            <input required type="email" value={form.email} onChange={update("email")} className="w-full mt-1 px-3 py-2.5 border border-[#E5D9C8] rounded-lg" data-testid="register-email-input" />
          </div>
          <div>
            <label className="text-xs uppercase font-bold tracking-widest text-[#8C6D53]">Password</label>
            <input required type="password" value={form.password} onChange={update("password")} className="w-full mt-1 px-3 py-2.5 border border-[#E5D9C8] rounded-lg" data-testid="register-password-input" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs uppercase font-bold tracking-widest text-[#8C6D53]">Phone</label>
              <input value={form.phone} onChange={update("phone")} placeholder="024XXXXXXX" className="w-full mt-1 px-3 py-2.5 border border-[#E5D9C8] rounded-lg" data-testid="register-phone-input" />
            </div>
            <div>
              <label className="text-xs uppercase font-bold tracking-widest text-[#8C6D53]">Region</label>
              <select value={form.region} onChange={update("region")} className="w-full mt-1 px-3 py-2.5 border border-[#E5D9C8] rounded-lg bg-white" data-testid="register-region-select">
                {REGIONS.map((r) => <option key={r} value={r}>{r}</option>)}
              </select>
            </div>
          </div>
          <button className="btn-primary w-full py-3 rounded-xl mt-2" data-testid="register-submit-button">Create account</button>
          <div className="text-sm text-center text-[#5C6660]">
            Already have one? <Link to="/login" className="text-[#C85A32] font-semibold">Sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
